// extracted by mini-css-extract-plugin
export default {"skeletonLoader":"AcademicYearFilter__skeletonLoader___JOhI2"};